import React, { useState } from 'react';

const STEPS = [
  { icon:'📋', title:'Choose Your Essay Type', desc:'Pick from 5 essay types — Discuss Both Views, Opinion, Advantages & Disadvantages, Problem & Solution, or Two Direct Questions. Each has its own formula tailored to that style.' },
  { icon:'✍️', title:'Write Sentence by Sentence', desc:'Each paragraph is broken into individual sentences. You write one at a time. This makes the task feel manageable and keeps your essay structured.' },
  { icon:'💡', title:'Use the Idea Bank', desc:'Stuck on what to write? Click the "Ideas" button on any sentence to get suggestions for main points, supporting examples, and relevant countries to mention.' },
  { icon:'🤖', title:'Get AI Feedback', desc:'Once you complete a paragraph, click "Get AI Feedback" to receive a Band score estimate, specific strengths, areas to improve, and a suggested rewrite from Claude.' },
];

export default function Onboarding({ onComplete }) {
  const [step, setStep] = useState(0);

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(26,42,74,0.7)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'#ffffff', borderRadius:16, maxWidth:500, width:'100%', overflow:'hidden', boxShadow:'0 20px 60px rgba(26,42,74,0.25)' }}>
        {/* Header */}
        <div style={{ background:'#1a2a4a', padding:'20px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, fontWeight:700, color:'#ffffff' }}>Welcome to IELTS<span style={{color:'#b8860b'}}>COMPASS</span></div>
          <button onClick={onComplete} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.4)', cursor:'pointer', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Skip tour</button>
        </div>

        {/* Step content */}
        <div style={{ padding:'32px 28px' }}>
          <div style={{ textAlign:'center', marginBottom:24 }}>
            <div style={{ fontSize:48, marginBottom:14 }}>{STEPS[step].icon}</div>
            <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color:'#1a2a4a', marginBottom:10 }}>{STEPS[step].title}</div>
            <div style={{ fontSize:13.5, color:'#5a6a88', lineHeight:1.75 }}>{STEPS[step].desc}</div>
          </div>

          {/* Step dots */}
          <div style={{ display:'flex', justifyContent:'center', gap:8, marginBottom:24 }}>
            {STEPS.map((_,i) => (
              <div key={i} style={{ width: i===step?24:8, height:8, borderRadius:100, background:i===step?'#b8860b':'#dde3ed', transition:'all .2s' }}/>
            ))}
          </div>

          {/* Buttons */}
          <div style={{ display:'flex', gap:10 }}>
            {step > 0 && (
              <button onClick={()=>setStep(s=>s-1)} style={{ flex:1, background:'#f7f9fc', border:'1px solid #dde3ed', color:'#5a6a88', padding:'11px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>← Back</button>
            )}
            <button onClick={()=>{ if(step<STEPS.length-1) setStep(s=>s+1); else onComplete(); }}
              style={{ flex:2, background:'#b8860b', color:'#ffffff', border:'none', padding:'11px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:"'Plus Jakarta Sans',sans-serif", boxShadow:'0 2px 8px rgba(184,134,11,0.3)' }}>
              {step < STEPS.length-1 ? 'Next →' : "Let's Start Writing →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
